import { httpRequests } from "investira.sdk";
import {
  POSICOES_UPLOAD,
  POSICOES_UPLOAD_LIST,
  POSICOES_LIST,
  POSICOES_DATAS,
  POSICOES_ADD,
  POSICOES_DELETE,
  POSICOES_DELETE_DATA,
  POSICOES_UPLOAD_DELETE,
  POSICOES_COPY,
  POSICOES_OPEN,
  POSICOES_FECHADA_LIST,
  POSICOES_FECHADA_ADD,
  POSICOES_FECHADA_DELETE,
  POSICOES_DOWNLOAD,
  POSICOES_ABERTA_RESUMO,
  POSICOES_ABERTA_PENDENCIA,
} from "../const/servicesURI";
import requestService from "./requestService";
import utils from "../utils";

export const cancel = {
  arquivos: null,
  datas: null,
};

export const upload = (pProps = {}, pResolve, pReject, pFinally) => {
  const xFormData = new FormData();

  xFormData.append(`file-${pProps.file.name}`, pProps.file);

  const xProps = {
    headers: { "Content-Type": "multipart/form-data" },
    data: xFormData,
    method: "post",
    onUploadProgress: pProps.onUploadProgress,
  };

  return requestService(xProps, POSICOES_UPLOAD, 3, 2400)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Posições Upload");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const download = (pUploadId, pResolve, pReject, pFinally) => {
  const xProps = {
    params: {
      upload_id: pUploadId,
    },
    responseType: "blob",
  };

  return requestService(xProps, POSICOES_DOWNLOAD, 3, 2400, true)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Posições Download");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const arquivos = (pProps, pResolve, pReject, pFinally) => {
  // if (cancel.arquivos) {
  //   cancel.arquivos.cancel();
  // }

  // cancel.arquivos = httpRequests.cancelToken();

  const xProps = {
    ...pProps,
    // cancelToken: cancel.arquivos.token,
  };

  return requestService(xProps, POSICOES_UPLOAD_LIST, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Posições Arquivos");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

// TODO: Este será para remover o ativo
export const remove = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: "delete",
  };

  return requestService(xProps, POSICOES_DELETE, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Posições Excluir");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const exclude = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: "delete",
  };

  return requestService(xProps, POSICOES_DELETE_DATA, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Posições Excluir");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const uploadRemove = (pParams, pResolve, pReject, pFinally) => {
  const xProps = {
    params: pParams,
    method: "delete",
  };

  return requestService(xProps, POSICOES_UPLOAD_DELETE, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Posições Excluir");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const datas = (pParams, pResolve, pReject, pFinally) => {
  // if (cancel.datas) {
  //   cancel.datas.cancel();
  // }

  // cancel.datas = httpRequests.cancelToken();

  const xProps = {
    params: pParams,
    //cancelToken: cancel.datas.token,
  };

  return requestService(xProps, POSICOES_DATAS, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Posições Datas");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const list = (pParams, pResolve, pReject, pFinally) => {
  const xProps = {
    params: pParams,
  };

  return requestService(xProps, POSICOES_LIST, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Posições Listar");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const add = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: "post",
  };

  return requestService(xProps, POSICOES_ADD, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Posições Adicionar");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const update = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: "patch",
  };

  return requestService(xProps, POSICOES_ADD, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Posições Update");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const copy = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: "post",
  };

  return requestService(xProps, POSICOES_COPY, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Posições Copy");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const open = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: "post",
    timeout: 240000,
  };

  return requestService(xProps, POSICOES_OPEN, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Posições Open");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const fechadasList = (pParams, pResolve, pReject, pFinally) => {
  const xProps = {
    params: pParams,
  };

  return requestService(xProps, POSICOES_FECHADA_LIST, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Posições Fechadas Listar");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const fechadasAdd = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: "post",
  };

  return requestService(xProps, POSICOES_FECHADA_ADD, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Posições Fechadas Add");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const fechadasRemove = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: "delete",
  };

  return requestService(xProps, POSICOES_FECHADA_DELETE, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Posições Fechadas Excluir");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const abertaResumo = (pParams, pResolve, pReject, pFinally) => {
  const xProps = {
    params: pParams,
  };

  return requestService(xProps, POSICOES_ABERTA_RESUMO, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Posições Aberta Resumo");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const abertaPendencia = (pParams, pResolve, pReject, pFinally) => {
  const xProps = {
    params: pParams,
  };

  return requestService(xProps, POSICOES_ABERTA_PENDENCIA, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Posições Aberta Pendência");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

const posicoes = {
  upload,
  arquivos,
  remove,
  cancel,
  list,
  add,
  datas,
  uploadRemove,
  update,
  copy,
  exclude,
  open,
  fechadasList,
  fechadasAdd,
  fechadasRemove,
  download,
  abertaResumo,
  abertaPendencia,
};

export default posicoes;
